import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import Maps from "../../../map/index";
import { Marker } from "react-google-maps";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide(props) {
 /* eslint-disable no-unused-vars */
  const [open, setOpen] = React.useState(true);
  const location =
    props.location && props.location.location ? props.location.location : null;

  function handleAction(type) {
    if (type && type === "close") props.closeModal();
    if (type && type === "confirm") props.confirmSend();
    //  setOpen(false);
  }

  return (
    <div>
      <Dialog
        open={open}
        maxWidth={"md"}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleAction("close")}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Confirmação de localização de incidente"}
        </DialogTitle>
        <DialogContent>
          <div style={{ height: 400, width: 800 }}>
            <Maps zoom={15} center={location}>
              <Marker position={location} />
            </Maps>
          </div>

          <DialogContentText
            id="alert-dialog-slide-description"
            style={{ marginTop: 10 }}
          >
            Ao confirmar o envio, todos os grupos que estiverem nessa
            localização irão receber a mensagem, você confirma os dados ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleAction("close")} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => handleAction("confirm")} color="primary">
            Confirmar envio
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
